import { useCallback, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  DEFAULT_INVENTORY_TRANSACTION_FILTERS,
  mergeInventoryTransactionFilters,
  parseInventoryTransactionFilters,
  type InventoryTransactionFilters,
  type TypeFilter,
} from './inventoryTransactionFilterParams';
import { DEFAULT_DATE_RANGE_PRESET } from '../../utils/dateRangePresets';

export type { InventoryTransactionFilters, TypeFilter };

export const useInventoryTransactionFilters = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const filters = useMemo(
    () => parseInventoryTransactionFilters(searchParams),
    [searchParams]
  );

  const listSearch = searchParams.toString();

  const updateFilters = useCallback(
    (patch: Partial<InventoryTransactionFilters>, options?: { replace?: boolean }) => {
      setSearchParams(mergeInventoryTransactionFilters(searchParams, patch), {
        replace: options?.replace ?? true,
      });
    },
    [searchParams, setSearchParams]
  );

  const clearFilters = useCallback(() => {
    setSearchParams({}, { replace: true });
  }, [setSearchParams]);

  const hasActiveFilters = useMemo(() => {
    return (
      filters.searchQuery !== DEFAULT_INVENTORY_TRANSACTION_FILTERS.searchQuery ||
      filters.itemFilter !== DEFAULT_INVENTORY_TRANSACTION_FILTERS.itemFilter ||
      filters.typeFilter !== DEFAULT_INVENTORY_TRANSACTION_FILTERS.typeFilter ||
      filters.datePreset !== DEFAULT_DATE_RANGE_PRESET
    );
  }, [filters]);

  return {
    filters,
    listSearch,
    updateFilters,
    clearFilters,
    hasActiveFilters,
  };
};
